import { Activity, ACTIVITY_TYPE } from './Activity';

export class Order extends Activity {
  srcCoin: COIN;
  destCoin: COIN;
  // Amount placed + tax
  amount: number;
  // Amount placed before tax
  origAmount: number;
  // Dollar value of the day
  coinValue: number;
  coinValueNumberStr?: string;
  coinValueDecimalStr?: string;
  //if market, amount is always in dollars
  market: boolean;
  subtype?: ORDER_SUBTYPE | ACTIVITY_TYPE;
  availableTime?: string;
  ticker?: number;

  constructor(amount: number, coinValue: number, pesoAdolar: boolean) {
    super();
    this.type = ACTIVITY_TYPE.ORDER;
    this.amount = amount;
    // eslint-disable-next-line no-self-assign
    this.origAmount = this.origAmount;
    this.coinValue = coinValue;
    //this.coinValueStr = coinValue.toFixed(2).padStart(2, '0');
    this.srcCoin = pesoAdolar ? 0 : 1;
    this.destCoin = pesoAdolar ? 1 : 0;
    this.creationTime = new Date();
    this.status = 0;
  }
}

export enum COIN {
  DOLAR = 0,
  PESO = 1,
  INSTRUMENT = 2,
  DAI = 3,
  DAI_USD = 4,
  ETH = 5,
  ETH_USD = 6,
}

export const COINS = {
  0: 'US$',
  1: 'AR$',
  2: 'CEDEAR',
  3: 'DAI',
  5: 'ETH',
};

export enum ORDER_SUBTYPE {
  SOLIDARIO = 0,
  COMPRA_INFINITO = 1,
  INVESTMENT = 3,
  CRYPTO = 4,
}

export const tickerMEP = 1045;
export const tickerMEPProd = 1245;

export enum ORDER_ERRORS {
  BAD_REQUEST = 'BAD_REQUEST',
  INVALID_PARAMS = 'INVALID_PARAMS',
  INVALID_PRICE_LOCK = 'INVALID_PRICE_LOCK',
  EXPIRED_LOCK = 'EXPIRED_LOCK',
  INVALID_LOCK = 'INVALID_LOCK',
  CODE_MISSING = 'CODE_MISSING',
  NO_FUNDS = 'NO_FUNDS',
  BLOCKED_SALE = 'BLOCKED_SALE',
  CANT_MULC = 'CANT_MULC',
  BLOCKED_UIF = 'BLOCKED_UIF',
  MIN_SIZE = 'MIN_SIZE',
  EXPIRED_PRICE = 'EXPIRED_PRICE',
  FORBIDDEN = 'FORBIDDEN',
  NO_CREDIT = 'NO_CREDIT',
  UNAUTHORIZED = 'UNAUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  ORDER_NF = 'ORDER_NF',
  USER_NF = 'USER_NF',
  COMPANY_NF = 'COMPANY_NF',
  PRICE_NF = 'PRICE_NF',
  USER_EXISTS = 'USER_EXISTS',
  USER_BLOCKED = 'USER_BLOCKED',
  COMPANY_EXISTS = 'COMPANY_EXISTS',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  DB_ERROR = 'DB_ERROR',
  NO_SEQUENCE = 'NO_SEQUENCE',
  NO_ACCOUNTS = 'NO_ACCOUNTS',
  NEEDS_EXTRA_BANK_ACCOUNT = 'NEEDS_EXTRA_BANK_ACCOUNT',
}

export enum LOW_STATUS_ERRORS {
  EMAIL_NOT_VERIFIED = 1,
  EXTRA_DATA_INCOMPLETE = 2,
  DNI_NOT_UPLOADED = 3,
  FUNDS_ORIGIN_NOT_UPLOADED = 4,
}

export enum ORDER_STATUS {
  PENDING = 0,
  COMPLETED = 1,
  CANCELLED = 2,
}

export enum STAKE_ERRORS {
  NO_FUNDS = 0,
  NO_ACCOUNT = 1,
  NO_STAKE = 2,
  IS_REMUNERATING = 3,
}

export enum OPERATION_TYPE {
  BUY = 'BUY',
  SELL = 'SELL',
}

export enum COIN_TYPE {
  SRC_COIN = 0,
  DEST_COIN = 1,
}
/**
 * Contiene las monedas que tengan las operaciones de compra o venta deshabilitadas
 */
export interface IOrderStatus {
  BUY: {
    coins: string[];
  };
  SELL: {
    coins: string[];
  };
}
